/**
 * Attach events to show more buttons linked to content to show full element based on css max-height
 *
 *
 * #my-id needs max-height set in CSS, after clicking .js-show-more button is removed and data-for element gets
 * max-height set to auto.
 *
 * If initially content is smaller than my-id container, button is removed and max-height set to auto
 *
 * @example
<div id="my-id">
 <div class="js-show-more__content">
   my long content...
 </div>
</div>

<div class="js-show-more" data-for="my-id">+ Read more</div>
 */

App.namespace.wrap('components.home_show_more', () => {
  const autoExpand = ($el, $showMoreButton) => {
    const containerHeight = $el.height();
    const contentHeight = $el.children('.js-show-more__content').height();

    if (contentHeight && contentHeight <= containerHeight) {
      $el.addClass('js-show-more--expanded');
      $showMoreButton.remove();
    }
  };

  const $showMore = $('.js-show-more');
  const $showLess = $('.js-show-more--undo');

  $showMore.on('click', (event) => {
    const $button = $(event.target);
    const id = $button.data('for');
    const $target = $(`#${id}`);

    $target.addClass('js-show-more--expanded');
    $button.hide();
    $(`.js-show-more--undo[data-for="${id}"]`).show();
  });

  $showLess.on('click', (event) => {
    const $button = $(event.target);
    const id = $button.data('for');
    const $target = $(`#${id}`);

    $target.removeClass('js-show-more--expanded');
    $button.hide();
    $(`.js-show-more[data-for="${id}"]`).show();
    $('body,html').scrollTop($target.offset().top - 200);
  });

  $showMore.each((index, el) => {
    const $el = $(el);
    const id = $el.data('for');
    const $target = $(`#${id}`);

    autoExpand($target, $el);
  });
});
